import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-[#fefce8] py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          {/* LEFT */}
          <div className="flex-1">
            <h1 className="text-3xl md:text-[42px] font-black text-secondary leading-tight mb-5">
              {t("hardware.h1")}
            </h1>
            <p className="text-base text-[#374151] leading-relaxed mb-6 max-w-lg">
              {t("hardware.subhead")}
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <a
                href="tel:+17863774452"
                className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-6 py-3 text-sm font-bold rounded-lg hover:bg-[#c2410c] transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line" />
                Call (786) 377-4452
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-transparent border-2 border-[#064e3b] text-secondary px-6 py-3 text-sm font-bold rounded-lg hover:bg-secondary hover:text-white transition-colors whitespace-nowrap"
              >
                Get Phone Quote
              </Link>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex-1">
            <img
              src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/86ec9310-db37-410d-82f2-2aa8c19790fd_DCIM_128APPLE_IMG_8508.jpg?v=f0bb6c7496a3006c252c141043bd8b8e"
              alt="Window hardware rollers locks hinges replacement Miami specialist"
              className="rounded-xl w-full object-cover max-w-[520px] mx-auto"
              onError={(e) => {
                (e.target as HTMLImageElement).src = "https://placehold.co/520x360/e2e8f0/1e293b?text=WINDOW+HARDWARE";
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}